import { queryOptions } from '@tanstack/react-query';
import { workspaceKey } from '../../lib/workspaceQueryKey';
import type { createApiClient } from '../../api/client';

/** The agreement row as `GET /cash-flow/agreement` returns it for a family caller. */
export interface Agreement {
  status: 'on' | 'off';
  windowMonths: number | null;
  windowStart: string | null;
  /** Opt-in (steward-app#2792): the only accounts Steward reads. */
  includedAccountIds: string[];
  agreementVersion: string | null;
  acceptedBy: string | null;
  acceptedAt: string | null;
}

/**
 * The ONE declaration of the agreement read, shared by Settings → Cash flow and the boards (steward-app#2593).
 * Two declarations with different key tails kept separate caches, so the board kept its old
 * "off" after Setup turned cash flow on. Settings also invalidates the board reads on a change.
 */
export function agreementQueryOptions(api: ReturnType<typeof createApiClient>, workspaceId: string | null, enabled: boolean) {
  return queryOptions({
    queryKey: workspaceKey('cash-flow-agreement', workspaceId),
    queryFn: () => api.get<{ agreement: Agreement | null }>('/cash-flow/agreement').then(r => r.agreement),
    enabled,
  });
}
